import {useMemo} from "react";
import {Tab} from "@headlessui/react";
import WorkspaceCommonSettingView from "../workspaceCommonSetting/WorkspaceCommonSettingView";
import GlobalVariablesSettingView from "../globalVariable/GlobalVariablesSettingView";
import GlobalVariableGroupSettingView from "../globalVariable/GlobalVariableGroupSettingView";

const SettingTab = () => {
    const tabList = useMemo(() => [
        {id: 1, title: "설정", disabled: false},
        {id: 2, title: "글로벌 변수", disabled: false},
        {id: 3, title: "글로벌 변수 그룹", disabled: false},
    ], [])

    const tabClassName = (selected: boolean) => {
        return selected
            ? "transition-colors duration-200 text-gray-500 pb-3 focus:outline-none text-gray-900 border-b border-black"
            : "transition-colors duration-200 text-gray-500 pb-3 focus:outline-none"
    }

    return (
        <div className="w-full h-full flex flex-col">

            <Tab.Group defaultIndex={0}>
                <Tab.List className="bg-white h-auto px-7 flex space-x-7 border-b">
                    {tabList.map(tab => (
                        <Tab key={tab.id}
                             disabled={tab.disabled}
                             className={({selected}) => tabClassName(selected)}>
                            {tab.title}
                        </Tab>
                    ))}
                </Tab.List>
                <Tab.Panels className="flex-grow">
                    <Tab.Panel className="h-full p-5">
                        <WorkspaceCommonSettingView/>
                    </Tab.Panel>
                    <Tab.Panel className="h-full p-5">
                        <GlobalVariablesSettingView/>
                    </Tab.Panel>
                    <Tab.Panel className="h-full p-5">
                        <GlobalVariableGroupSettingView/>
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
        </div>
    )
};

export default SettingTab;